import {Dutch} from "flatpickr/dist/l10n/nl";

window.$ = window.jQuery = require('jquery');
window._ = require('lodash');

require('bootstrap');
require('./custom');
require('./tinymce');
require('./axios');
require('./vue');



import flatpickr from 'flatpickr';
flatpickr.localize(Dutch);

let short_months = ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'];
let months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
let short_days = ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'];
let days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
const firstDayOfTheWeek = 1;

flatpickr('.time-picker', {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    allowInput: true,
    defaultHour: 8,
    locale: {
        firstDayOfWeek: firstDayOfTheWeek,
        months: {
            shorthand: short_months,
            longhand: months
        },
        weekdays: {
            shorthand: short_days,
            longhand: days
        }
    }
});

flatpickr('.length-picker', {
    enableTime: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    allowInput: true,
    defaultHour: 0,
    locale: {
        firstDayOfWeek: firstDayOfTheWeek,
        months: {
            shorthand: short_months,
            longhand: months
        },
        weekdays: {
            shorthand: short_days,
            longhand: days
        }
    }
});

flatpickr('.date-picker', {
    dateFormat: "d-m-Y",
    allowInput: true
});

flatpickr('.date-time-picker', {
    enableTime: true,
    dateFormat: "d-m-Y / H:i",
    time_24hr: true,
    allowInput: true,
    defaultHour: 8,
    locale: {
        firstDayOfWeek: firstDayOfTheWeek,
        months: {
            shorthand: short_months,
            longhand: months
        },
        weekdays: {
            shorthand: short_days,
            longhand: days
        }
    }
});



function detectMob() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}


var weekdays = {
    1: 'Maandag',
    2: 'Dinsdag',
    3: 'Woensdag',
    4: 'Donderdag',
    5: 'Vrijdag',
    6: 'Zaterdag',
    7: 'Zondag'
};
var workScheduleWrap = document.getElementById('workScheduleWrap');
var workScheduleDayNew = document.getElementById('workScheduleDayNew');
var workSchedulesSize = document.getElementsByClassName('work-schedule-day-js').length;
if(workSchedulesSize >= 7 && workScheduleDayNew) {
    workScheduleDayNew.classList.add('work-schedule-day--hide')
}
var workScheduleIdCount = 0;

window.createDay = function () {

    if(workSchedulesSize < 7) {
        var workScheduleDay = document.createElement('div');
        workScheduleDay.classList.add('work-schedule-day');


        var weekdayFormGroup = document.createElement('div');
        weekdayFormGroup.classList.add('form-group');


        var weekdayLabel = document.createElement('label');
        weekdayLabel.setAttribute('for', 'weekdayJs' + workScheduleIdCount);
        weekdayLabel.innerHTML = 'Dag';
        var weekdaySelect = document.createElement('select');
        weekdaySelect.classList.add('form-control');
        weekdaySelect.id = 'weekdayJs' + workScheduleIdCount;
        weekdaySelect.name = 'weekday[]';
        for (let key in weekdays) {
            var weekdayOption = document.createElement('option');
            weekdayOption.value = key;
            weekdayOption.innerHTML = weekdays[key];
            weekdaySelect.appendChild(weekdayOption);
        }

        weekdayFormGroup.appendChild(weekdayLabel);
        weekdayFormGroup.appendChild(weekdaySelect);
        workScheduleDay.appendChild(weekdayFormGroup);


        var startFormGroup = document.createElement('div');
        startFormGroup.classList.add('form-group');
        var startLabel = document.createElement('label');
        startLabel.setAttribute('for', 'startJs' + workScheduleIdCount);
        startLabel.innerHTML = 'Starttijd';
        var startInput = document.createElement('input');
        startInput.style = 'max-height: 36px';
        startInput.classList.add('form-control');
        startInput.id = 'startJs' + workScheduleIdCount;
        startInput.name = 'start[]';
        startInput.value = '08:00';
        if(detectMob())
        {
            startInput.type = 'time';
        }
        else
        {
            startInput.type = 'text';
            flatpickr(startInput, {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                allowInput: true,
                defaultHour: 8
            });
        }

        startFormGroup.appendChild(startLabel);
        startFormGroup.appendChild(startInput);

        workScheduleDay.appendChild(startFormGroup);


        var hourFormGroup = document.createElement('div');
        hourFormGroup.classList.add('form-group');
        var hourLabel = document.createElement('label');
        hourLabel.setAttribute('for', 'hoursJs' + workScheduleIdCount);
        hourLabel.innerHTML = 'Totale uren';
        var hourInput = document.createElement('input');
        hourInput.classList.add('form-control');
        hourInput.type = 'number';
        hourInput.step = '0.1';
        hourInput.id = 'hoursJs' + workScheduleIdCount;
        hourInput.name = 'hours[]';
        hourInput.value = '0';

        hourFormGroup.appendChild(hourLabel);
        hourFormGroup.appendChild(hourInput);

        workScheduleDay.appendChild(hourFormGroup);


        var breakFormGroup = document.createElement('div');
        breakFormGroup.classList.add('form-group');
        var breakLabel = document.createElement('label');
        breakLabel.setAttribute('for', 'breakJs' + workScheduleIdCount);
        breakLabel.innerHTML = 'Onbetaalde pauze in minuten';
        var breakInput = document.createElement('input');
        breakInput.classList.add('form-control');
        breakInput.type = 'text';
        breakInput.id = 'breakJs' + workScheduleIdCount;
        breakInput.name = 'break[]';
        breakInput.value = '0';
        breakFormGroup.appendChild(breakLabel);
        breakFormGroup.appendChild(breakInput);
        workScheduleDay.appendChild(breakFormGroup);

        var workScheduleDayClose = document.createElement('span');
        workScheduleDayClose.classList.add('work-schedule-day-close');
        workScheduleDayClose.innerHTML = '&times;';
        workScheduleDayClose.addEventListener('click', function () {
            this.parentNode.remove();
            if(workSchedulesSize == 7 && workScheduleDayNew) {
                workScheduleDayNew.classList.remove('work-schedule-day--hide');
            }
            workSchedulesSize--;
        });
        workScheduleDay.appendChild(workScheduleDayClose);

        if(workScheduleWrap) {
            workScheduleWrap.insertBefore(workScheduleDay, workScheduleWrap.children[workScheduleWrap.children.length - 1]);
        }

        if(workSchedulesSize == 6 && workScheduleDayNew) {
            workScheduleDayNew.classList.add('work-schedule-day--hide');
        }

        workSchedulesSize++;
        workScheduleIdCount++;
    }

};



window.deleteWorkScheduleDay = function (id) {
    var workScheduleDay = document.getElementById(id);
    if(workScheduleDay) {
        workScheduleDay.remove();
    }
    if(workSchedulesSize == 7 && workScheduleDayNew) {
        workScheduleDayNew.classList.remove('work-schedule-day--hide');
    }
    workSchedulesSize--;
};


let hamburger = document.getElementById('hamburger');
if(hamburger)
{
    hamburger.addEventListener('click', function () {
        document.getElementById('sidebar').classList.add('sidebar-offcanvas-active');
    });
}


let hamburger_close = document.getElementById('hamburger_close');
if(hamburger_close)
{
    hamburger_close.addEventListener('click', function () {
        document.getElementById('sidebar').classList.remove('sidebar-offcanvas-active');
    });
}


const info_circles = document.getElementsByClassName('info-circle-wrap');
const info_pop_ups = document.getElementsByClassName('info-pop-up-wrap');

setup_info_pop_ups();

for(let i = 0; i < info_circles.length; i++)
{
    info_circles[i].addEventListener('mouseover', () => {
        info_pop_ups[i].classList.remove('info-pop-up-wrap--hide');
    });
    info_pop_ups[i].addEventListener('mouseover', () => {
        info_pop_ups[i].classList.remove('info-pop-up-wrap--hide');
    });
    info_circles[i].addEventListener('mouseout', () => {
        info_pop_ups[i].classList.add('info-pop-up-wrap--hide');
    });
    info_pop_ups[i].addEventListener('mouseout', () => {
        info_pop_ups[i].classList.add('info-pop-up-wrap--hide');
    });
}

window.onresize = function () {
    if(window.innerWidth > 767 && document.getElementById('sidebar'))
    {
        document.getElementById('sidebar').classList.remove('sidebar-offcanvas-active');
    }
    setup_info_pop_ups();
};

function setup_info_pop_ups()
{
    for (let i = 0; i < info_circles.length; i++)
    {
        let rect = info_pop_ups[i].parentNode.getBoundingClientRect();
        if(window.innerWidth > 320)
        {
            if(rect.left + 300 + 15 > window.innerWidth) {
                info_pop_ups[i].style = 'margin-left: -' + (rect.left + 300 - window.innerWidth + 15) + 'px;';
            }
            else
            {
                info_pop_ups[i].style = '';
            }
        }
        else
        {
            if(rect.left + 300 + 10 > window.innerWidth) {
                info_pop_ups[i].style = 'margin-left: -' + (rect.left + 300 - window.innerWidth + 10) + 'px;';
            }
            else
            {
                info_pop_ups[i].style = '';
            }
        }

    }
}

let increaseButton = document.getElementById("mutatie-button-plus");
let decreaseButton = document.getElementById("mutatie-button-min");
let increaseButtonMin = document.getElementById("mutatie-button-plus-minuten");
let decreaseButtonMin = document.getElementById("mutatie-button-min-minuten");
let urenDoc = document.getElementById("hours");
let minutenDoc = document.getElementById("minutes");

if (increaseButton && decreaseButton && increaseButtonMin && decreaseButtonMin && urenDoc && minutenDoc){
    urenDoc.addEventListener('input', (event) => checkColors());
    minutenDoc.addEventListener('input', (event) => checkColors());

    increaseButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (urenDoc.value == '-0'){
            urenDoc.value = '0';
        } else if (urenDoc.value == '-1') {
            urenDoc.value = '-0';
        } else {
            urenDoc.value++;
        }

        checkColors();
    });

    decreaseButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (urenDoc.value == '0'){
            urenDoc.value = '-0';
        } else {
            urenDoc.value--;
        }

        checkColors();
    });

    increaseButtonMin.addEventListener("click", (event) => {
        event.preventDefault();
        if (urenDoc.value.startsWith('-')){
            minutenDoc.value -= 5;
            if (minutenDoc.value < 0){
                minutenDoc.value = 55;
                if (urenDoc.value == '-0'){
                    urenDoc.value = '0';
                    minutenDoc.value = 5;
                } else if (urenDoc.value == '-1') {
                    urenDoc.value = '-0';
                } else {
                    urenDoc.value++;
                }
            }
        } else {
            minutenDoc.value -= -5;
            if (minutenDoc.value == 60){
                minutenDoc.value = 0;
                if (urenDoc.value == '-0'){
                    urenDoc.value = 0;
                } else {
                    urenDoc.value++;
                }
            }
        }

        checkColors();
    });

    decreaseButtonMin.addEventListener("click", (event) => {
        event.preventDefault();
        if (urenDoc.value.startsWith('-')){
            minutenDoc.value -= -5;
            if (minutenDoc.value < 0 && urenDoc.value == '-0'){
                urenDoc.value = '0';
                minutenDoc.value = 5;
            } else if (minutenDoc.value == 60){
                minutenDoc.value = 0;
                urenDoc.value--;
            } else {

            }
        } else {
            minutenDoc.value -= 5;
            if (minutenDoc.value < 0){
                minutenDoc.value = 55;
                if (urenDoc.value == '0'){
                    urenDoc.value = '-0';
                    minutenDoc.value = 5;
                } else {
                    urenDoc.value--;
                }
            }
        }

        checkColors();
    });

    function checkColors() {
        const hours = urenDoc.value, minutes = minutenDoc.value;
        let totalMinutes = 0;

        if (hours > 0 || hours < 0){
            totalMinutes = (hours * 60) + ((urenDoc.value.startsWith('-') ? -minutes : minutes) * 1.666666666666667)
        } else if (hours == '-0'){
            totalMinutes = -minutes * 1.666666666666667;
        } else {
            totalMinutes = minutes * 1.666666666666667;
        }

        if (totalMinutes > 0){
            applyColor("green");
        } else if (totalMinutes < 0){
            applyColor('red')
        } else {
            applyColor('gray')
        }
    }

    function applyColor(color) {
        urenDoc.style.color = color;
        minutenDoc.style.color = color;
    }
}

$(function () {
    //$('[data-toggle="tooltip"]').tooltip()
	$("nav .accordion #headingOne").click(function(){
		$(this).siblings().slideToggle()
	});

	$('.navbar-nav .dropdown-toggle').click(function(){
		$(this).siblings().slideToggle()
	});

    $(document).on('click', '[data-toggle=modal]', function(){
        $($(this).attr('data-target')).removeClass('fade');
        $($(this).attr('data-target')).addClass('show');
    });

    $(document).on('click', '.modal [data-dismiss=modal]', function(){
        $(this).closest('.modal').addClass('fade');
        $(this).closest('.modal').removeClass('show');
    });


});
